<i18n src='../common_locales.yaml'></i18n>

<template lang="pug">
.list-group-item.section-cart-detail(v-if="isCartDetail")
  .row
    .col-md-7.d-flex.flex-row
      img.img-product-small.mr-3(:src="item.product.image_url")
      .div
        p.text-product-name {{locale_product_name}}
        p.mb-0.text-secondary ¥ {{ item.product.price }}
      span.icon-delete.ml-auto.d-md-none(@click="pushDelete") ×
    .col-md-5
      .section-quantity.d-flex.flex-row.align-items-center
        .btn-incrementer(@click="pushDecreaseQuantity")
          <svg viewBox="0 0 64 64" width="16px" height="16px" class=" lo"><g><path d="M55 36H9a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h46a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1z"></path></g></svg>
        .text-quantity {{ itemQuantity }}
        .btn-incrementer(@click="pushIncreaseQuantity")
          <svg viewBox="0 0 64 64" width="16px" height="16px" class=" lo"><path d="M56 29v6a1 1 0 0 1-1 1H36v19a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V36H9a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h19V9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v19h19a1 1 0 0 1 1 1z"></path></svg>
        .section-price.ml-auto
          .text-price ¥ {{ totalPrice }}
            span.icon-delete.ml-2.d-none.d-md-inline-block(@click="pushDelete") ×
tr.section-snippet.cart-item(v-else)
  td.item-quantity-icon
    span(@click="pushDecreaseQuantity") -
  td.item-quantity-text.text-center {{ itemQuantity }}
  td.item-quantity-icon
    span(@click="pushIncreaseQuantity") +
  td.text-left.item-name
    span {{ locale_product_name }}
  td.item-price
    span ¥ {{ totalPrice }}
    span.ml-2.icon-cancel(@click="pushDelete") ×
</template>

<script>
import { mapActions } from 'vuex'
import api from '../api'

export default {
  name: 'cart-item',
  props: ['index', 'item', 'isCartDetail'],
  data () {
    return {
      itemQuantity: this.item.quantity
    }
  },
  computed: {
    locale_product_name () {
      return this.item.product['name_' + this.$i18n.locale]
    },
    totalPrice () {
      return this.item.quantity * this.item.product.price
    }
  },
  mounted () {
    this.syncProductWithRemote()
  },
  methods: {
    ...mapActions([
      'removeItemFromCart',
      'increaseItemQuantity',
      'decreaseItemQuantity',
      'updateCartSubAmount',
      'updateCartProduct'
    ]),
    pushDelete () {
      this.removeItemFromCart(this.item.product.id)
      this.updateCartSubAmount(-this.totalPrice)
    },
    pushIncreaseQuantity () {
      this.itemQuantity++
      this.increaseItemQuantity(this.item)
    },
    pushDecreaseQuantity () {
      if (this.itemQuantity === 1) {
        return
      }
      this.itemQuantity--
      this.decreaseItemQuantity(this.item)
    },
    syncProductWithRemote () {
      api.get(`/bentos/${this.item.product.public_ident}/`).then(response => {
        this.updateCartProduct({index: this.index, product: response.data})
      })
    }
  }
}
</script>

<style lang="scss">
.section-snippet {
  .item-quantity-icon {
    padding-left: 0 !important;
    padding-right: 0 !important;
    cursor: pointer;
    font-weight: 700;
    color: #888;
  }

  .item-quantity-text {
    padding-left: .5rem !important;
    padding-right: .5rem !important;
  }

  .item-name {
    word-break: break-word;
    width: 80%;
    cursor: pointer;
    font-weight: 500;
  }

  .item-price {
    text-align: right;
    white-space: nowrap;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .div-quantity {
    min-width: 100px;
  }

  .quantity {
    margin-left: .75rem;
    margin-right: .75rem;
  }
}
.section-cart-detail {
  .btn-incrementer {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    display: flex;
    border: 1px solid #E0E0E0;
    cursor: pointer;
  }
  .text-product-name {
    font-weight: 500;
    margin-bottom: 0;
  }
  .text-quantity {
    font-weight: 500;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .text-price {
    font-weight: 500;
  }
  .btn-quantity {
    width: 36px;
    height: 36px;
    background-color: #07c748;
    color: #fff;
    border-radius: 50%;
  }
  .icon-delete {
    cursor: pointer;
    font-weight: 300;
    color: #888;
    font-size: 1.5rem;
  }
}

@media (max-width: 767px) {
  .section-cart-detail {
    .section-quantity {
      margin-top: .5rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/CartItem.vue